import styled from "styled-components";
import { Space } from "antd";

const Title = styled.div`
  padding-top: 16px;
  padding-bottom: 24px;
  font-size: 24px;
  font-weight: 700;
  color: #1e1e1e;
`;

const TopBox = styled.div`
  padding: 20px 24px;
  border-radius: 8px;
  width: 100%;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  background: linear-gradient(90deg, #c1e1ff 0%, #f0f6fe 100%);

  .ant-btn {
    min-width: 172px;
    height: 48px;
  }

  .ant-btn-default {
    border: 1px solid ${(props) => props.theme.primaryColor} !important;
  }
`;

const TopWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  justify-content: center;
`;

const BoldText = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #1e1e1e;
`;

const Text = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #1e1e1e;
`;

const TextGray = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #868686;
`;

const Card = styled.div`
  border-radius: 8px;
  padding: 16px;
  background-color: ${(props) => props.theme.backgroundColor};
  border: 1px solid ${(props) => props.theme.primaryColor};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
`;

const TextWrapper = styled(Space)`
  width: 100%;
  align-items: center;

  .ant-space-item {
    display: flex;
  }

  .ant-space-item:first-child {
    flex: 1;
  }
`;

const ProductItem = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 8px;
  align-items: center;
`;

const TextSm = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #1d1014;
`;

const TextSmGray = styled(TextSm)`
  color: #868686;
`;

const TextSmPrimary = styled(TextSm)`
  color: ${(props) => props.theme.primaryColor};
`;

const GrayCard = styled.div`
  border-radius: 8px;
  padding: 16px;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StepItem = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;

  .ant-space {
    flex: 1;
    width: 100%;
    gap: 4px !important;
  }
`;

const StepNoBox = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: ${(props) => props.theme.primaryColor};

  font-size: 14px;
  font-weight: 700;
  color: #fff;
`;

export {
  StepNoBox,
  StepItem,
  GrayCard,
  TextSmPrimary,
  TextSmGray,
  TextSm,
  ProductItem,
  TextWrapper,
  Wrapper,
  Card,
  TextGray,
  Text,
  BoldText,
  TopWrapper,
  TopBox,
  Title,
};
